import { Box } from '@mui/system'
import { observer } from 'mobx-react-lite'
import { Multi2Icon } from './Multi2Icon'
import { Multi3Icon } from './Multi3Icon'
import { Multi4Icon } from './Multi4Icon'
import { Multi5Icon } from './Multi5Icon'
import { Multi6Icon } from './Multi6Icon'
import { Multi7Icon } from './Multi7Icon'
import { Multi8Icon } from './Multi8Icon'
import { Multi9Icon } from './Multi9Icon'
import { Multi9PlusIcon } from './Multi9PlusIcon'

interface Props {
  amount: number
  zoom?: number
  size?: number
}
export const MultipleIcon = observer(({ amount, zoom, size }: Props) => {
  if (amount <= 1) return <Box></Box>

  const sxAttr = {
    height: `${size ?? 32}px`,
    width: `${size ?? 32}px`,
    transform: `scale(${(zoom ?? 100) / 100})`,
  }

  if (amount === 2) return <Multi2Icon sx={sxAttr} />
  if (amount === 3) return <Multi3Icon sx={sxAttr} />
  if (amount === 4) return <Multi4Icon sx={sxAttr} />
  if (amount === 5) return <Multi5Icon sx={sxAttr} />
  if (amount === 6) return <Multi6Icon sx={sxAttr} />
  if (amount === 7) return <Multi7Icon sx={sxAttr} />
  if (amount === 8) return <Multi8Icon sx={sxAttr} />
  if (amount === 9) return <Multi9Icon sx={sxAttr} />

  return <Multi9PlusIcon sx={sxAttr} />
})
